// extracted by mini-css-extract-plugin
export var glitterContainer = "glitterEffect-module--glitterContainer--e9207";